import React from 'react';
import Icon from '@/components/icon/Icon';
import { IconsDictionary } from '@/components/icon/Icon.types';
import ButtonStyled from './ButtonStyled';

export enum ButtonStyles {
  Primary = 'primary',
  Secondary = 'secondary',
  Tertiary = 'tertiary',
  Warning = 'warning',
}

export enum ButtonTypes {
  Default = 'button',
  Submit = 'submit',
  Reset = 'reset',
}
interface Props {
  className?: string;
  type: ButtonTypes;
  label: string;
  _onClick?: (e: React.MouseEvent<Element>) => void;
  _onEnterPressed?: (e: React.KeyboardEvent<Element>) => void;
  btnStyle?: ButtonStyles;
  icon?: IconsDictionary;
  iconColor?: string;
  isLabelHidden?: boolean;
  isDisabled?: boolean;
}

const Button = ({
  className,
  btnStyle = ButtonStyles.Primary,
  type = ButtonTypes.Default,
  label,
  _onClick,
  _onEnterPressed,
  icon,
  iconColor,
  isLabelHidden,
  isDisabled,
}: Props) => {
  return (
    <ButtonStyled
      className={className}
      type={type}
      btnStyle={btnStyle}
      disabled={isDisabled}
      onClick={e => {
        if (_onClick) _onClick(e);
      }}
      onKeyDown={evt => {
        if (evt.key === 'Enter') {
          if (_onEnterPressed) _onEnterPressed(evt);
        }
      }}
      hasIcon={icon ? true : false}
    >
      {icon && <Icon icon={icon} color={isDisabled ? '#fff' : iconColor} />}
      <span className={isLabelHidden ? 'sr-only' : ''}>{label}</span>
    </ButtonStyled>
  );
};

export default Button;
